import { useMutation, gql } from "@apollo/client"
import { TASK_FIELDS } from "./useQueryOrganisationTemplates"

const CREATE_TASK_MUTATION = gql`
  mutation CreateTask(
    $name: String!
    $description: String
    $priority: Int
    $after: ScheduleDateInput
    $due: ScheduleDateInput
    $pinned: Boolean
    $users: [ID!]
    $groups: [ID!]
    $uploads: [ID!]
    $locations: [ID!]!
  ) {
    createTask(
      name: $name
      description: $description
      priority: $priority
      after: $after
      due: $due
      pinned: $pinned
      users: $users
      groups: $groups
      uploads: $uploads
      locations: $locations
    ) {
      ${TASK_FIELDS}
    }
  }
`

const useMutationCreateTask = () => useMutation(CREATE_TASK_MUTATION)

export { useMutationCreateTask }
